<style scoped  lang="less">
    @import '../../../style/reset.less'; // 引入公共LESS文件
    .detailsTabBox{
      height: 100px;overflow: hidden; padding: 0 16px; margin: 0 -16px;
    }
   .detailsTab{
    height: 100px; background: @color_FFF;
    .tabTop{
      // background: @color_FFF; 
      // border-bottom: 1px solid @color_F0F0F0 ;

      border-bottom: 1px solid @color_F0F0F0;
      position: relative;
      background: @color_FFF;
        &::before {
            content: '';
            display: block;
            width: 16px;position: absolute;left: -16px;bottom: 0;height: 100%;background: @color_FFF;
        }
        &::after {
            content: '';
            display: block;
            width: 16px;position: absolute;right: -16px;bottom: 0;height: 100%;background: @color_FFF;
        }
      .flex();
      a{display: block;margin: 0 32px;padding: 0 1px;
        color: @color_000;
        font-size: 14px;
        font-weight: 600;
        line-height: 38px;
        white-space: nowrap;
        &.on{
          color: @color_FF6915;
          border-bottom: 2px solid @color_FF6915;
        }
      }
    }
    .subset{
      padding: 16px 0;
        .flex();
      a{
        display: block;
        margin-right: 8px;
        height: 22px;
        padding: 2px 16px;
        border-radius: 4px;
        border: 1px solid @color_BFBFBF;
        background: @color_FFF;
        color: @color_434343;
        font-size: 14px;
        line-height: 22px;
        &.on{
          background:  @color_FF6915;
          border: 1px solid @color_FF6915;
          color: @color_FFF;
        }
      }
    }
   }
   .detailsTabShow{
    height: 41px;
   }
   .detailsTab_on{
    position: relative;  height: 41px;
    //       &::after{
    //         &::before {
    //         content: '';
    //         display: block;
    //         width: 1168px;position: absolute;left: 16px;bottom: 0;height: 1px;background: @color_F0F0F0;
    //     }
    // }
    // border-bottom: 1px solid @color_F0F0F0 ;
     height: 41px;
    .subset{display: none;}
   }

  @media screen and (max-width: 767px) {
    .detailsTabBox{
      height: 0.78rem;
    }
    .detailsTab{
      height: 0.78rem;
      .tabTop{
        width: 100%; overflow-x: auto; border-bottom: 1px solid @color_F0F0F0 ;
        margin:0;padding:0;
        // top:0.44rem;
        &::before { 
            display: none; 
        }
        &::after {
            content: '';
            display: none; 
        }
        &::-webkit-scrollbar {
          width: 0rem; display: none!important;
        }

        &::-webkit-scrollbar-thumb {
          /* 设置滚动条手柄颜色 */
        }
        &::-webkit-scrollbar-track {
         /* 设置滚动条轨道颜色 */
        }
        a{margin: 0 0.16rem;padding: 0 0.01rem;
          
          font-size: 0.14rem;
          
          line-height: 0.38rem;
          &.on{
            
          }
        }
      }
      .subset{
        padding: 0.08rem 0.08rem ;
        width: 100%; overflow-x: auto;
        &::-webkit-scrollbar {
          width: 0rem; display: none!important;
        }
        a{
          
          margin-right: 0.1rem;
          height: 0.24rem;
          padding: 0rem 0.16rem;
          border-radius: 0.04rem;
          white-space: nowrap;
          
          font-size: 0.14rem;
          line-height: 0.24rem;
        }
      }
    }
    .detailsTabShow{
    height: 0.39rem;
   }
    .detailsTab_on{
      height: 0.38rem;
      margin: 0;
      padding: 0; 
      border-bottom: none ;
      left: 0;top:0.44rem;width: 100%; position: fixed;
      &::after{
            &::before { 
            width: 100%;left: 0;bottom: 0;height: 0.01rem;
        }
      }
    }

  }
</style>
<template>
  <div >
    <div class="detailsTabBox"  :class="(!tabList[tabObj[tabData.tabId].index].child.length>0?'detailsTabShow':'')"> 
      <div class="detailsTab" :class="(isHeadDown?'detailsTab_on':'')" v-if="match">
        <div class="tabTop flex">
          <!-- <a href="javascript:void(0);" class="on">Match</a> 
          <a href="javascript:void(0);">Odds</a> 
          <a href="javascript:void(0);">H2H</a> 
          <a href="javascript:void(0);">Standings</a> 
          <a href="javascript:void(0);">Prediction</a>  -->
          <template v-for="(item, index) in tabList">
          <a href="javascript:void(0);" :class="item.id==tabData.tabId?'on':''" :key="index" @click="onTabChange(
            item.id,
            (item.child.length>0?item.child[0].id:0),
            (item.child.length>0?item.child[0].name:item.name)
            )" v-if="isShow(item.id,0)">
              {{item.name}}
            </a>
          </template>
        </div>
        <!-- v-if="tabShow" -->
        <template v-if="tabShow">
          <div class="subset" v-if="tabList[tabObj[tabData.tabId].index].child.length>0">
            <!-- <a href="javascript:void(0);" class="on">Summary</a> 
            <a href="javascript:void(0);">Stats</a> 
            <a href="javascript:void(0);">LineUps</a> 
            <a href="javascript:void(0);">Event</a>  -->
            <template v-for="(item, index) in tabList[tabObj[tabData.tabId].index].child">
              <a href="javascript:void(0);" :class="item.id==tabData.childID?'on':''" :key="index" @click="onTabChange(tabList[tabObj[tabData.tabId].index].id,item.id),item.name" v-if="isShow(tabList[tabObj[tabData.tabId].index].id,item.id)">{{item.name}}</a>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabList:[
        {
          name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['MATCH'],
          id:'1',
          child:[
            {
              name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['SUMMARY'],
              id:'1',
            },{
              name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['STATS'],
              id:'2',
            },{
              name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['LINEUP'],
              id:'3',
            },{
              name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['EVENT'],
              id:'4',
            },
          ]
        },
        {
          name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['ODDS'],
          id:'2',
          child:[
          ]
        },
        {
          name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['H2H'],
          id:'3',
          child:[
          ]
        },
        {
          name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['STANDING'],
          id:'4',
          child:[
            // {
            //   name:'All',
            //   id:'1',
            // },{
            //   name:'Home',
            //   id:'2',
            // },{
            //   name:'Away',
            //   id:'3',
            // }
          ]
        },
        {
          name: this.langConfig.details[this.langConfig.curLang]['TAB_LIST']['PREDICTION'],
          id:'5',
          child:[
          ]
        }
      ],
      tabData:{// 
        tabId:1,
        childID:1
      },
      tabObj:null,
      tabShow:false,
    }
  },
  methods: { 
    //数据转换
    getTabObj(){
      const tabList = JSON.parse(JSON.stringify(this.tabList));
      const tabObj = {};
      tabList.forEach((tabList_i, index) => {
        tabObj[tabList_i.id] = {
          index,
          child: tabList_i.child.reduce((childObj, child_i, childIndex) => {
            childObj[child_i.id] = childIndex;
            return childObj;
          }, {})
        };
      });
      this.tabObj = tabObj;
      //console.log('tabObj',tabObj);
     
      if(this.newTabData){
        this.tabData=this.newTabData;
      }
      this.tabShow=true;
    },
    isShow(tabId,childID){
      var match=JSON.parse(JSON.stringify(this.match));
      if(!match){
        return true;
      }
      let hasLineup=match.hasLineup||false;//是否有阵容 0非1=正式2=预测
      let hasStats=match.hasStats||false;//是否有统计 0非1是
      let hasEventLive=match.hasEventLive||false;//是否有事件直播 0非1是
      let hasLuck=match.hasLuck||false;//是否有指
      let hasPrediction=match.hasPrediction||false;//是否有指
      let hasStanding=match.hasStanding||false;//积分版
      
      //console.log('阵容',hasLineup,'Stats统计',hasStats,'直播',hasEventLive,'指数',hasLuck,'积分',hasStanding);
      if(tabId==1&&childID==3&&!hasLineup){
        return false;
      }else if(tabId==1&&childID==2&&!hasStats){
        return false;
      }else if(tabId==1&&childID==4&&!hasEventLive){
        return false;
      }else if(tabId==2&&!hasLuck){
        return false;
      }else if(tabId==5&&!hasPrediction){//tabId==5&&!hasPrediction
        return false;
      }else if(tabId==4&&!hasStanding){//积分版
        return false;
      }
      return true;

    },
    //切换
    onTabChange(tabId,childID,name){
      let tabData={
        tabId:tabId,
        childID:childID,
        name:name
      }
      this.tabData=tabData;
      this.$emit('onTabChange',tabData)
    },
    getTabData(){
      return this.tabData;
    },
    setTabData(tabId,childID){
       this.tabData={
        tabId:tabId,
        childID:childID
      };
    }

  },
  created() {
    this.getTabObj();
  },
  watch: {
    newTabData(val){
      if(val){
        //console.log('val-newTabData',val);
        // this.tabData=val;
        this.getTabObj();
      }

    }
  },
  mounted() {
    
  },
  beforeDestroy() {
   
  },
  props: {
    newTabData: {
      type: Object,
      default:null
    }, 
    // options:{
    //   type:Array,
    //   default:() =>[],
    // },
    // format: {
    //   type: String,
    //   default:'DD/MM/YYYY WW'
    // },
    // showToday:{
    //   type: Boolean,
    //   default:false
    // },

    isHeadDown:{
      type: Boolean,
      default:false
    },

    //比赛信息
    match: {
      type: Object,
      default: null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsTab.vue